
import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { NotificacionesContent } from './components/NotificacionesContent';

export default function MisVisitasNotificaciones() {

    return (
        <>
            <MainContent
                component={<NotificacionesContent />}
                titulo={'Notificaciones'}
                noBackground
                tableMaxWidth
            />
        </>
    );

};
